import React, { useState, useEffect } from 'react';
import '../css/Header.css';
import '../css/Body.css';

/* 폰트어썸 import */
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getUserAccount, getIsLogin } from '../utils/session';

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))
(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
    borderBottom: 0,
    },
    '&:before': {
    display: 'none',
    },
}));
  
const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
      {...props}
    />
))
(({ theme }) => ({
    backgroundColor:
    theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, .05)'
        : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
    },
}));
  
const AccordionDetails = styled(MuiAccordionDetails)
(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

function MobileCustomer() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userAccount = getUserAccount() || {};
    const isLogin = getIsLogin();
    useEffect(() => {
        if (!isLogin || !userAccount) {
            navigate('/mobile');
            return;
        }
    }, []);

    return (
        <div className="container">
            <div className="frame-19">
                <div className="frame-20">
                    <div className="text-wrapper-14">고객센터</div>
                    <p className="p">연락처 : 070-4352-0624</p>
                    <p className="p">팩&nbsp;&nbsp;&nbsp;스 : 070-4325-0624</p>
                    <p className="p">이메일 : support@semiquz.co.kr</p>
                </div>
                <div className="frame-20">
                    <div className="text-wrapper-14">주소</div>
                    <p className="p">
                        경기도 평택시 고덕중앙로 200-4<br />
                        (고덕동, 우성고덕타워) (우 18014)
                    </p>
                </div>
                <div className="frame-20">
                    <div className="text-wrapper-14">Address</div>
                    <p className="p">
                        200-4, Godeokjungang-ro,<br />
                        Pyeongtaek-si, Gyeonggi-do,<br />
                        Republic of Korea (zip code : 18014)
                    </p>
                </div>
                <Button
                    style={{
                        backgroundColor: '#4e82eb',
                        borderRadius:'8px',
                        padding: '6px 64px',
                        border: 'none',
                        color:'white',
                        display: 'block',
                        margin: '6px auto 0'
                    }} 
                    variant="outlined"
                >
                    사용설명서
                </Button>
            </div>
        </div>
    )
}

export default MobileCustomer;
